// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"7e780f99","453":"4752be5c","956":"8a0f953a"}[chunkId] + ".chunk.js";
};